<template>
  <div class="sidebar">
    <div class="sidebar__media-library">
      <div class="sidebar__media-list">
        <span class="list-name color-alternate display-4">Media library</span>
        <ul class="list display-3">
          <li class="list__item">
          <router-link class="list__link" to="/artists">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              fill="#fff"
              width="15px"
              height="15px"
              viewBox="0 0 981.6 981.6"
              xml:space="preserve"
            >
              <g>
                <path
                  d="M50.562,981.6c12.8,0,25.6-4.9,35.4-14.6l82-82l-35.9-35.9l-34.9-34.9l-82,82c-19.5,19.5-19.5,51.201,0,70.701
		C24.962,976.699,37.763,981.6,50.562,981.6z"
                />
                <path
                  d="M714.562,0c-64.6,1.5-128.7,26.9-177.9,76.2c-20.5,20.5-36.8,43.5-49.099,68.1l20.599,20.6l154,154l154,154l20.601,20.6
		c24.6-12.2,47.6-28.6,68.1-49.1c49.3-49.3,74.7-113.4,76.2-177.9l-12.1,12.1c-6.801,6.8-15.801,10.3-24.7,10.3
		c-9,0-17.9-3.4-24.7-10.3c-13.7-13.7-13.7-35.8,0-49.5l49.1-49.1c-8.899-27.4-22.399-53.7-40.6-77.5l-67.5,67.5
		c-6.8,6.8-15.8,10.3-24.7,10.3c-9,0-17.899-3.4-24.7-10.3c-13.699-13.7-13.699-35.8,0-49.5l67.5-67.5
		c-23.8-18.2-50.1-31.7-77.5-40.6l-49.1,49.1c-6.8,6.8-15.8,10.3-24.7,10.3c-9,0-17.899-3.4-24.7-10.3
		c-13.699-13.7-13.699-35.8,0-49.5L714.562,0z"
                />
                <path
                  d="M458.662,214.4l-348.1,439.1c-18.9,23.9-17,58.199,4.6,79.699l31.5,31.5l34.9,34.9l35.9,35.9l30.5,30.5
		c11.6,11.6,27,17.6,42.4,17.6c13.101,0,26.3-4.299,37.3-13l439.1-348.1l-4.9-4.9l-149.2-149.1L463.562,219.4L458.662,214.4z"
                />
              </g>
            </svg>
            <span class="list__link-text">Artists</span>
          </router-link>
          </li>
          <li class="list__item">
            <router-link class="list__link" to="/albums">
              <svg
                fill="#fff"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 50 50"
                width="15px"
                height="15px"
              >
                <path
                  d="M 13 4 C 8.0414839 4 4 8.0414839 4 13 L 4 37 C 4 41.958516 8.0414839 46 13 46 L 37 46 C 41.958516 46 46 41.958516 46 37 L 46 13 C 46 8.0414839 41.958516 4 37 4 L 13 4 z M 13 6 L 37 6 C 40.877484 6 44 9.1225161 44 13 L 44 37 C 44 40.877484 40.877484 44 37 44 L 13 44 C 9.1225161 44 6 40.877484 6 37 L 6 13 C 6 9.1225161 9.1225161 6 13 6 z M 33.560547 11.001953 C 33.450344 10.996441 33.337354 11.004324 33.224609 11.025391 L 33.222656 11.025391 L 20.630859 13.386719 C 19.691698 13.563432 19 14.397117 19 15.353516 L 19 28.986328 A 1.0001 1.0001 0 0 0 19 29 C 19 30.116666 18.116666 31 17 31 L 15.169922 31 C 13.046743 31 11.12071 32.594135 11.005859 34.787109 C 10.886899 37.073786 12.732105 39 15 39 L 15.5 39 C 18.525577 39 21 36.525577 21 33.5 L 21 29 L 21 20.455078 L 33 18.205078 L 33 26 C 33 27.116666 32.116666 28 31 28 L 29.169922 28 C 27.046743 28 25.12071 29.594135 25.005859 31.787109 C 24.886899 34.073786 26.732105 36 29 36 L 29.5 36 C 32.525577 36 35 33.525577 35 30.5 L 35 26 L 35 12.5 C 35 11.697435 34.331969 11.040538 33.560547 11.001953 z M 33 13.103516 L 33 16.169922 L 21 18.419922 L 21 15.353516 L 33 13.103516 z M 33 29.380859 L 33 30.5 C 33 32.444423 31.444423 34 29.5 34 L 29 34 C 27.847895 34 26.940913 33.063948 27.001953 31.890625 C 27.057102 30.837599 28.045101 30 29.169922 30 L 31 30 C 31.742658 30 32.401869 29.738341 33 29.380859 z M 19 32.380859 L 19 33.5 C 19 35.444423 17.444423 37 15.5 37 L 15 37 C 13.847895 37 12.940913 36.063948 13.001953 34.890625 C 13.057102 33.837599 14.045101 33 15.169922 33 L 17 33 C 17.742658 33 18.401869 32.738341 19 32.380859 z"
                />
              </svg>
              <span class="list__link-text">Albums</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="sidebar__media-list">
        <span class="list-name color-alternate display-4">Playlists</span>
        <ul class="list display-3">
          <li class="list__li">
            <a href="#" class="list__link">
              <svg
                fill="#fff"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                width="15px"
                height="15px"
                viewBox="0 0 122.88 107.41"
              >
                <g>
                  <path
                    class="st0"
                    d="M60.83,17.19C68.84,8.84,74.45,1.62,86.79,0.21c23.17-2.66,44.48,21.06,32.78,44.41 c-3.33,6.65-10.11,14.56-17.61,22.32c-8.23,8.52-17.34,16.87-23.72,23.2l-17.4,17.26L46.46,93.56C29.16,76.9,0.95,55.93,0.02,29.95 C-0.63,11.75,13.73,0.09,30.25,0.3C45.01,0.5,51.22,7.84,60.83,17.19L60.83,17.19L60.83,17.19z"
                  />
                </g>
              </svg>
              <span class="list__link-text"> Likes </span></a
            >
          </li>
        </ul>
      </div>
      <!-- <div class="sidebar__media-list">
        <span class="list-name color-alternate display-4">Что сделать</span>
        <ul class="list display-3">
          <li class="list__li">
            <a href="#" class="list__link">
              <span class="list__link-text">Поиск</span>
            </a>
          </li>
          <li class="list__li">
            <a href="#" class="list__link">
              <span class="list__link-text">Перемешку треков</span>
            </a>
          </li>
          <li class="list__li">
            <a href="#" class="list__link">
              <span class="list__link-text">Идея с функцией которая принимает параметром ++trackIndex или --</span>
            </a>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "i-sidebar",
};
</script>

<style lang="scss" scoped></style>
